import styled from '../../styled';
export const LoadingSpinnerWrapper = styled.span `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 0;
  > svg {
    > circle {
      stroke: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].loadingSpinnerColor]};
    }
  }
`;
export const ContentWrapper = styled.div `
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
  margin-top: -0.125rem;
  white-space: nowrap;
  > svg {
    display: inline-block;
    vertical-align: middle;
  }

  > span {
    display: inline-block;
    vertical-align: middle;
  }

  > :not(:first-child) {
    margin-left: 0.25rem;
  }
`;
const OutlineButtonKeys = ['outline', 'outlineBasic', 'outlinePrimary'];
export const Container = styled.button `
  display: inline-block;
  position: relative;
  font-size: 0.875rem;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-align: center;
  box-shadow: ${({ buttonKey, buttonTheme }) => buttonTheme === 'clearButtons' || OutlineButtonKeys.includes(buttonKey)
    ? 'none'
    : '0 0.0625rem 0.125rem 0.0625rem rgba(54, 62, 81, 0.1)'};
  border: solid ${({ theme, buttonTheme }) => theme[buttonTheme].border.NORMAL}
    transparent;
  outline: none;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out,
    box-shadow 0.1s ease-in-out, opacity 0.1s ease-in-out;
  will-change: background-color, color, box-shadow, opacity;
  box-sizing: border-box;
  cursor: pointer;

  &:not(:active) {
    background-color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].backgroundColor]};
    color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].textColor]};
    border: ${({ theme, buttonKey, buttonTheme }) => `solid ${theme[buttonTheme].border.NORMAL} ${theme.colors[theme[buttonTheme].types[buttonKey].borderColor]}`};
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].hoverBackgroundColor]};
    color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].hoverTextColor]};
    box-shadow: ${({ buttonKey, buttonTheme }) => OutlineButtonKeys.includes(buttonKey) || buttonTheme === 'clearButtons'
    ? 'none'
    : '0 0.0625rem 0.125rem 0.0625rem rgba(54, 62, 81, 0.1), 0 0 1.5rem 0 rgba(54, 62, 81, 0.05)'};
    opacity: ${({ theme, buttonKey, buttonTheme }) => theme[buttonTheme].types[buttonKey].hoverOpacity};
    span,
    div,
    p {
      color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].hoverTextColor]};
    }

    svg,
    path {
      fill: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].hoverTextColor]};
    }
  }

  &:disabled {
    background-color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].disabledBackgroundColor]};
    color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].disabledTextColor]};
    border-color: ${({ theme, buttonKey, isLoading, buttonTheme }) => isLoading
    ? theme.colors[theme[buttonTheme].types[buttonKey].borderColor]
    : theme.colors[theme[buttonTheme].types[buttonKey].disabledBorderColor]};
    box-shadow: none;
    cursor: not-allowed;
    svg,
    path {
      fill: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].disabledTextColor]};
    }
  }

  &:active:not(:disabled) {
    background-color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].activeBackgroundColor]};
    color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].activeTextColor]};
    border-color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].borderColor]};
    * {
      color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].activeTextColor]};
      fill: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].activeTextColor]};
    }
  }

  &.is-focus {
    border: solid ${({ theme, buttonTheme }) => theme[buttonTheme].border.BOLD}
      ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].focusInnerBorderColor]};
    color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].focusTextColor]};

    span,
    div,
    p {
      color: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].focusTextColor]};
    }

    svg,
    path {
      fill: ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].focusTextColor]};
    }
  }

  &.is-focus:active:not(:disabled) {
    border: solid ${({ theme, buttonTheme }) => theme[buttonTheme].border.BOLD}
      ${({ theme, buttonKey, buttonTheme }) => theme.colors[theme[buttonTheme].types[buttonKey].focusInnerBorderColor]};
  }

  ${props => props.block === true &&
    `
      display: block;
      width: 100%;
    `}
`;
//# sourceMappingURL=elements.js.map